import "./src/styles/style.css";
import ReactDOM from "react-dom/client";
import "./src/fragments/gutenberg";

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const shouldUpdateScroll = ({ pathname }) => {
  // Kurs list pages handle their own scroll restoration via sessionStorage
  if (pathname?.includes("/kurs-og-konferanser/")) {
    return false;
  }
  return true;
};
